import { render, staticRenderFns } from "./MenuLanguagesList.vue?vue&type=template&id=678fb398&scoped=true&"
import script from "./MenuLanguagesList.vue?vue&type=script&lang=js&"
export * from "./MenuLanguagesList.vue?vue&type=script&lang=js&"
import style0 from "./MenuLanguagesList.vue?vue&type=style&index=0&id=678fb398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fb398",
  null
  
)

export default component.exports